import { useInfoCard } from '../hooks/useInfoCard';
import { textPositionTokens } from '../tokens';

export function InfoCardTextContainer({ children }) {
	const { isFullModeStyle, textPosition, blockClass, handles } = useInfoCard();

	function renderTokens() {
		const alignToken = textPositionTokens[textPosition || 'left'];
		const paddingLeftToken = textPosition === 'right' ? 'pl' : 'pr';

		if (isFullModeStyle) {
			return `mh8-ns mh4-s w-40-ns items-${alignToken}`;
		}

		return `w-50-ns ph3-s items-start ${paddingLeftToken}4-ns`;
	}

	return <div className={`${handles.infoCardTextContainer} flex flex-column mw-100 ${renderTokens()}`}>{children}</div>;
}
